import {Component, OnInit} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {BaseComponent} from "../base/base.component";
import {ActivatedRoute, Router, Params} from '@angular/router';
import {AlertService} from "../services/alert.service";
import {AuthService} from "../services/auth.service";

@Component({
  selector: 'micro-task-getResource',
  templateUrl: './task-getResource.component.html'
})
export class TaskGetResourceComponent {
  taskCarrierId:any;
  taskProductId:any;
  standbyUsers:any;

  constructor(protected env: EnvService,
              protected http: HttpClient,
              private route: ActivatedRoute,
              private router:Router,
              private authService:AuthService,
              private alertService:AlertService) {
  }

  search() {
    var params:HttpParams = new HttpParams()
      .set("taskCarrierId", this.taskCarrierId)
      .set("taskProductId", this.taskProductId)
    ;

    this.http.get(`${this.env.e.url}/task/omni/standbyResources`, {params:params}).subscribe(
      data => {
        this.standbyUsers = data;
      }
    );
  }
}
